<template>
  <div class="animated fadeIn col-md-12">
    <b-row>
      <b-col cols="12">
        <b-card>
          <LoadingSpinner
            :loading="isLoading"
            :text="this.$lang.sending_data"
          />
          <div slot="header">
            ایجاد
            <strong v-text="$lang.address" />
          </div>
          <b-alert variant="danger" show dismissible v-show="errors.length > 0">
            <li v-bind:key="index" v-for="(error, index) in errors">
              {{ error }}
            </li>
          </b-alert>
          <b-form @submit.prevent="save" v-show="!isLoading">
            <b-row>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.type"
                  label-for="kind_selected"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.type"
                    :rules="$v.kind_selected.$params"
                  />
                  <selectFind
                    :options="address_kind_options"
                    v-model="$v.kind_selected.$model"
                    label="text"
                    :isValid="
                      $v.kind_selected.$dirty ? !$v.kind_selected.$error : null
                    "
                  />

                  <b-form-invalid-feedback
                    id="kind_selected-feedback"
                    :style="{
                      display: $v.kind_selected.$error ? 'block' : 'none',
                    }"
                  >
                    {{
                      $lang.error_required | replace($lang.address_kind)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.name_city"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.name_city"
                    :rules="$v.location_selected.$params"
                  />
                  <selectAsync
                    :options="location_options"
                    v-model="$v.location_selected.$model"
                    label="caption"
                    :asyncFind="getLocation"
                    :isValid="
                      $v.location_selected.$dirty
                        ? !$v.location_selected.$error
                        : null
                    "
                    :loading="location_loading"
                    :placeholder="$lang.search_city"
                  />

                  <b-form-invalid-feedback
                    :style="{
                      display: $v.location_selected.$error ? 'block' : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{ $lang.error_required | replace($lang.name_city) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  type="year-month"
                  label-for="from_year"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.from_year"
                    :rules="$v.from_year.$params"
                  />
                  <date-picker
                    v-model="$v.from_year.$model"
                    :state="$v.from_year.$dirty ? !$v.from_year.$error : null"
                    inputReq="true"
                    @input="changeToYear($v)"
                    auto-submit
                    clearable
                    simple
                    type="year"
                    format="jYYYY"
                    display-format="jYYYY"
                    :max="new Date() | moment('jYYYY')"
                    :class="
                      $v.from_year.$dirty
                        ? $v.from_year.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{ display: $v.from_year.$error ? 'block' : 'none' }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.from_year)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  type="year-month"
                  label-for="to_year"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.to_year"
                    :rules="$v.to_year.$params"
                  />
                  <date-picker
                    v-model="$v.to_year.$model"
                    :state="$v.to_year.$dirty ? !$v.to_year.$error : null"
                    inputReq="true"
                    :max="new Date() | moment('jYYYY')"
                    auto-submit
                    clearable
                    simple
                    type="year"
                    format="jYYYY"
                    display-format="jYYYY"
                    :min="`${$v.from_year.$model}`"
                    :class="
                      $v.to_year.$dirty
                        ? $v.to_year.$error
                          ? 'invalid-date'
                          : 'valid-date'
                        : null
                    "
                  >
                  </date-picker>
                  <b-form-invalid-feedback
                    :style="{ display: $v.to_year.$error ? 'block' : 'none' }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required | replace($lang.to_year)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.postal_code"
                  label-for="address"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.postal_code"
                    :rules="$v.postal_code.$params"
                  />
                  <b-form-input
                    id="postal_code"
                    type="text"
                    v-model="$v.postal_code.$model"
                    :state="
                      $v.postal_code.$dirty ? !$v.postal_code.$error : null
                    "
                    :autocomplete="$lang.postal_code"
                    class="text-right"
                  ></b-form-input>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.postal_code.minLengh | !$v.postal_code.maxLengh"
                  >
                    {{ $lang.error_length | replace($lang.postal_code, 10) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="6">
                <b-form-group
                  :label="$lang.phone"
                  label-for="tel"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.phone"
                    :rules="$v.tel.$params"
                  />
                  <b-form-input
                    id="tel"
                    type="text"
                    v-model="$v.tel.$model"
                    :state="$v.tel.$dirty ? !$v.tel.$error : null"
                    :autocomplete="$lang.phone"
                    class="text-right"
                  >
                  </b-form-input>
                  <div
                    class="invalid-feedback"
                    v-if="!$v.tel.minLengh | !$v.tel.maxLengh"
                  >
                    {{ $lang.error_length | replace($lang.phone, 11) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.regional_municipality"
                  label-for="regional_municipality"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.regional_municipality"
                    :rules="$v.regional_municipality.$params"
                  />
                  <b-form-input
                    id="regional_municipality"
                    type="text"
                    v-model="$v.regional_municipality.$model"
                    :state="
                      $v.regional_municipality.$dirty
                        ? !$v.regional_municipality.$error
                        : null
                    "
                    :autocomplete="$lang.regional_municipality"
                    class="text-right"
                  >
                  </b-form-input>
                  <b-form-invalid-feedback
                    :style="{
                      display: $v.regional_municipality.$error
                        ? 'block'
                        : 'none',
                    }"
                    id="gender_id-feedback"
                  >
                    {{
                      $lang.error_required
                        | replace($lang.regional_municipality)
                    }}</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.address"
                  label-for="address"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.address"
                    :rules="$v.content.$params"
                  />
                  <b-form-textarea
                    id="content"
                    type="text"
                    v-model="$v.content.$model"
                    :state="$v.content.$dirty ? !$v.content.$error : null"
                    :autocomplete="$lang.address"
                    :rows="this.$config.form.textareaRows"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="father_name-feedback"
                    >{{ $lang.error_required | replace($lang.address) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col cols="12" md="12">
                <b-form-group
                  :label="$lang.description"
                  label-for="address"
                  :label-cols="$config.form.labelCol"
                >
                  <requiredComponent
                    slot="label"
                    :label="$lang.description"
                    :rules="$v.description.$params"
                  />
                  <b-form-textarea
                    id="description"
                    type="text"
                    v-model="$v.description.$model"
                    :autocomplete="$lang.description"
                    :rows="this.$config.form.textareaRows"
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <div slot="footer" class="form-group form-btn">
              <b-button
                type="reset"
                class="mr-2"
                variant="outline-danger"
                @click="handleBack"
              >
                <mdicon name="close" size="20" />
                {{ $lang.cancelButton }}
              </b-button>
              <b-button
                v-if="isAdmin(parentPermissions)"
                type="submit"
                variant="success"
              >
                <mdicon name="check" size="20" />
                {{ $lang.submitButton }}
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import {
  required,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { renderEumOptions, isAdmin } from "@/shared/utils";

export default {
  validations: {
    kind_selected: {
      required,
    },
    location_selected: { required },
    tel: {},
    from_year: {},
    to_year: {},
    regional_municipality: {},
    postal_code: {
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10),
    },
    description: {},
    content: {},
  },
  name: "add-address",
  components: {
    datePicker: VuePersianDatetimePicker,
    LoadingSpinner,
  },
  props: {
    entity: {
      type: String,
      default: "person",
    },
    entityId: {
      type: String,
    },
    isModal: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: String,
      default: "",
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      from_year: null,
      to_year: null,
      isLoading: false,
      kind_selected: null,
      description: null,
      content: null,
      postal_code: null,
      cityLoading: false,
      provinceLoading: false,
      errors: [],
      location_options: [],
      location_selected: null,
      location_loading: false,
      allowPermissions: ["admin", "edit"],
      showPermissionButton: false,
    };
  },
  computed: {
    address_kind_options() {
      return renderEumOptions(`${this.entity}_address_kind`);
    },
  },
  methods: {
    pathOr,
    renderEumOptions,
    isAdmin,
    changeToYear(item) {
      if (this.to_year && item.from_year.$model > this.to_year) {
        item.to_year.$model = "";
      }
    },
    async getLocation(query) {
      if (!query || query.length < 2) {
        return;
      }
      if (query.length > 2) {
        this.location_options = [];
      }

      try {
        this.location_loading = true;
        const url = `${this.$config.api_url}${this.$config.resources.location}?city=${query}`;
        const response = await this.$httpService.get(url);
        this.location_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.location_loading = false;
      }
    },
    handleBack() {
      if (this.isModal) {
        this.$emit("modal-end-up");
      } else {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push("/");
      }
    },
    clear() {
      this.name = "";
      this.description = "";
      this.category_id = null;
      this.exercise_id = null;
    },
    afterSave() {
      if (this.backUrl) {
        this.$route.push(this.backUrl);
      } else {
        this.handleBack();
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }

      try {
        this.isLoading = true;
        const api_url = this.$config.resources[
          `${this.entity}_address`
        ].replace("{0}", this.entityId);
        const url = this.$config.api_url + api_url;
        const payload = {
          kind_id: this.kind_selected.value,
          zone_number: this.regional_municipality,
          location_id: pathOr(null, ["id"], this.location_selected),
          address: this.content,
          postal_code: this.postal_code,
          description: this.description,
          tel: this.tel,
          to_year: this.to_year,
          from_year: this.from_year,
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.afterSave();
        this.$emit("getItems");
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
